import { BaseEntity } from "@app/common";
import { BundleProduct } from "@app/products-base";
import { prop, required } from "@messaia/cdk";

export class TariffChangeBundleProductEquivalence extends BaseEntity {
    @prop()
    id: number;

    @required()
    fromBundleProductId: number | null;
    fromBundleProduct: BundleProduct;

    @required()
    toBundleProductId: number | null;
    toBundleProduct: BundleProduct;

    @prop()
    retained: boolean;

    /**
     * constructor
     * @param init 
     */
    public constructor(init?: Partial<TariffChangeBundleProductEquivalence>) {
        super(init);
        Object.assign(this, init);
    }
}